import React from 'react';

import ImageSequence from './ImageSequence.js';

import image from '../images/tux.png';


export default ({startSize, n, mobileN}) => <ImageSequence
    n={n} mobileN={mobileN}
    imageGetter={i => [image, startSize / Math.pow(2, i), `Downscaled ${i} times`]}
/>;
